import { Factory } from "../../core/factory";

export const registerMarkFilterTransform = () => {
    Factory.registerGrammarTransform("filter", {
        transform: (options, data) => null == data ? void 0 : data.filter(options.callback)
    });
};
//# sourceMappingURL=filter.js.map
